import React, { useCallback, useEffect, useState } from "react";
import ToolBar from "../../../components/ToolBar";
import { AppDispatch } from "../../../store/app";
import { useDispatch } from "react-redux";
import ListTable from "./components/ListTable";
import { Button, Result } from "antd";
import AddReport from "./components/AddReport";
import SearchList from "./components/SearchList";
import { checkPrivileges } from "../../../config/Global";
import { fetchListAsteriskNumberByShadowPrefixReports } from "../../../store/asteriskNumberByShadowPrefixReportSlice";

const AsteriskNumberByShadowPrefixReports: React.FC = () => {
  const dispatch: AppDispatch = useDispatch();
  const [listData, setListData] = useState<any[]>([]);
  const [totalData, setTotalData] = useState<any>(0);
  const [tableloading, setTableLoading] = useState<boolean>(false);
  const [savePayload, setSavePayload] = useState<any>();
  const [paginationData, setPaginationData] = useState<any>({
    current: 1,
    page_size: 10,
  });
  const [openAddModal, setOpenAddModal] = useState<boolean>(false);

  const userDetails = localStorage.getItem("userDetails");
  const userRoles = userDetails && JSON.parse(userDetails)?.roles;

  const getList = useCallback(
    (data?: any) => {
      setTableLoading(true);
      const payload = {
        ...data,
        current: data?.current ?? paginationData?.current ?? 1,
        page_size: data?.page_size ?? paginationData?.page_size ?? 10,
      };
      setSavePayload(payload);

      if (checkPrivileges(userRoles, "admin")) {
        dispatch(fetchListAsteriskNumberByShadowPrefixReports(payload))
          .then((res: any) => {
            setListData(res?.data);
            setTotalData(res?.total_data);
            setTableLoading(false);
          })
          .catch(() => {
            setListData([]);
            setTotalData(0);
            setTableLoading(false);
          });
      }
    },
    [dispatch, paginationData, userRoles]
  );

  const handleAddModal = () => {
    setOpenAddModal(!openAddModal);
  };

  useEffect(() => {
    getList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <ToolBar
        title={"Asterisk Number By Shadow Prefix Reports"}
        children={
          <>
            {checkPrivileges(userRoles, "admin") ? (
              <Button type="primary" onClick={handleAddModal}>
                Add New
              </Button>
            ) : null}
          </>
        }
      />
      {checkPrivileges(userRoles, "admin") ? (
        <>
          <SearchList
            handleAddModal={handleAddModal}
            openAddModal={openAddModal}
            getList={getList}
          />

          <ListTable
            listData={listData}
            setListData={setListData}
            totalData={totalData}
            tableloading={tableloading}
            setTableLoading={setTableLoading}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
            getList={getList}
            savePayload={savePayload}
          />
        </>
      ) : (
        <Result
          status="403"
          title="403"
          subTitle="You don't have enough permission to perform this action."
        />
      )}

      {openAddModal ? (
        <AddReport
          handleAddModal={handleAddModal}
          openAddModal={openAddModal}
          getList={getList}
        />
      ) : null}
    </>
  );
};
export default AsteriskNumberByShadowPrefixReports;
